import React from "react";

const Logo = (props) => {
  return (
    <img
      src="/images/logo.png"
      alt="Logo"
      {...props}
      style={{ width: "60px" }}   //180
    />
  );
};

export default Logo;
